import { inject, Pipe, PipeTransform } from '@angular/core';
import { BazisConfigurationService } from '@bazis/configuration.service';
/**
 * ScheduleTimePipe converts minutes to HH:mm string.
 *
 * If the input is null/undefined, it returns `BazisConfigurationService.emptyInputValue`.
 * Example: 75 -> "01:15".
 *
 * Template usage:
 *```html
 *   @if (durationInMinutes as mins) {
 *       <span>{{ mins | scheduleTime }}</span>
 *   }
 * ```
 *
 */
@Pipe({
    name: 'scheduleTime',
    standalone: true,
})
export class ScheduleTimePipe implements PipeTransform {
    protected configurationService = inject(BazisConfigurationService);

    /**
     * Convert minutes to HH:mm string.
     *
     * @param value Minutes number (e.g., 75 -> 01:15).
     * @returns HH:mm string or `emptyInputValue` when input is null/undefined.
     */
    transform(value: number): string {
        if (!value && value !== 0) return this.configurationService.emptyInputValue;
        const min = value % 60;
        const minStr = min < 10 ? `0${min}` : `${min}`;
        const h = Math.floor(value / 60);
        const hourStr = h < 10 ? `0${h}` : `${h}`;

        return `${hourStr}:${minStr}`;
    }
}
